<script setup>
import { useAxiosDropdown } from '@/composables/useAxiosDropdown.js';

const props = defineProps({
    seccion: {
        type: String,
        required: false,
    },
    url: {
        type: String,
        required: true,
    },
    havetransactions: {
        type: Boolean,
        default: false,
    },
    validationvisibility: {
        type: String,
        default: 'dirty',
    },
});

const { makeRequest, results, error } = useAxiosDropdown()

async function getOptions({ search }) {
    let url = new URL(props.url, import.meta.env.VITE_API_URL);

    if (search.trim() != "") {
        url.searchParams.append('searchtext', search);
    }

    if (props.vigencia && props.vigencia != "")
        url.searchParams.append('anualidad', props.vigencia);

    if (props.havetransactions && props.havetransactions != "")
        url.searchParams.append('haveTransactions', props.havetransactions);

    await makeRequest(url.toString());
    if (!error.value) {
        return results.value.results.map((result) => {
            return {
                label: `${result.codigo} - ${result.seccion}`,
                value: result.id,
                codigo: result.codigo,
                seccion: result.seccion,
            }
        })
    }
    return []
}

async function reHydrate(id, cachedOption) {
    if (cachedOption) return cachedOption
    let url = new URL(props.url, import.meta.env.VITE_API_URL);
    url.searchParams.append('id', id);
    url.searchParams.append('anualidad', props.vigencia);
    await makeRequest(url.toString());
    console.log(id);
    if (!error.value) {
        return {
            label: `${results.value.results[0].codigo} - ${results.value.results[0].seccion}`,
            value: results.value.results[0].id,
            codigo: results.value.results[0].codigo,
            seccion: results.value.results[0].seccion,
        }
    }
    return { label: 'Error cargando' }
}
</script>


<template>
    <FormKit :option-loader="reHydrate" type="autocomplete"
        :options="getOptions"   selection-removable open-on-focus :label-class="{
            'form-label': true,
            'formkit-label': false,
            'fw-bold': true,
        }" :wrapper-class="{
            'formkit-wrapper': false
        }" validation-visibility="validationvisibility">
        <template #option="{ option, classes }">
            <div :class="classes.option">
                <span :class="{ 'fw-bold': option.attrs && option.attrs.disabled === true }"><b>{{ option.codigo
                }}</b> - {{ option.seccion }}</span>
            </div>
        </template>
    </FormKit>
</template>
